import { render, staticRenderFns } from "./OrganizationLogoEditCard.vue?vue&type=template&id=436bf52c&"
import script from "./OrganizationLogoEditCard.vue?vue&type=script&lang=ts&"
export * from "./OrganizationLogoEditCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('436bf52c')) {
      api.createRecord('436bf52c', component.options)
    } else {
      api.reload('436bf52c', component.options)
    }
    module.hot.accept("./OrganizationLogoEditCard.vue?vue&type=template&id=436bf52c&", function () {
      api.rerender('436bf52c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/member/OrganizationLogoEditCard.vue"
export default component.exports